module.exports = __webpack_public_path__ + "img/logo-icon.e5443fc2.png";